/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  GamoraBase64URLGuard,
  GamoraErrorUnhandledException,
  assert,
} from '@ver.id/libs.internal.gamora';
import { HoruzProtocolChulakDataType } from '../../data.js';
import { HoruzProtocolChulakMessageGuard } from './base.js';

/**
 * Input type
 * @public
 */
export interface HoruzProtocolChulakMessageAgentStartEnterGuardInput {}

/**
 * @public
 */
export class HoruzProtocolChulakMessageAgentStartEnterGuard extends HoruzProtocolChulakMessageGuard<
  HoruzProtocolChulakDataType.STATE_AGENT_START_ENTER,
  HoruzProtocolChulakMessageAgentStartEnterGuardInput
> {
  /**
   * Constructor
   * @param input - the input
   */
  constructor(input: HoruzProtocolChulakMessageAgentStartEnterGuardInput) {
    super();
  }

  /**
   * Gets type
   */
  get type(): HoruzProtocolChulakDataType.STATE_AGENT_START_ENTER {
    return HoruzProtocolChulakDataType.STATE_AGENT_START_ENTER;
  }

  /**
   * Gets from JSON
   * @param input - Input string
   */
  static override fromJSON(
    input: unknown,
  ): HoruzProtocolChulakMessageAgentStartEnterGuard {
    assert(
      typeof input === 'object' && input !== null,
      'Invalid input argument: not an object.',
    );
    return new HoruzProtocolChulakMessageAgentStartEnterGuard(
      input as HoruzProtocolChulakMessageAgentStartEnterGuardInput,
    );
  }

  /**
   * Get from base64URL
   * @param input - The input
   */
  static override fromBase64URL(
    input: unknown,
  ): HoruzProtocolChulakMessageAgentStartEnterGuard {
    assert(
      typeof input === 'string' && input.length > 0,
      'Invalid input argument: not a valid string.',
    );

    // Parse input
    let json;
    try {
      json = JSON.parse(GamoraBase64URLGuard.fromBase64URL(input).toUTF8());
    } catch (e) {
      throw new GamoraErrorUnhandledException(
        'Unable to parse input: not valid JSON in base64url input.',
      );
    }

    // Create new guard
    return new HoruzProtocolChulakMessageAgentStartEnterGuard(
      json as HoruzProtocolChulakMessageAgentStartEnterGuardInput,
    );
  }

  /**
   * Gets JSON
   * @returns string
   */
  override toJSON() {
    return {};
  }

  /**
   * To Base64URL
   */
  override toBase64URL(): string {
    const json = this.toJSON();
    return GamoraBase64URLGuard.fromUTF8(JSON.stringify(json)).toBase64URL();
  }

  /**
   * Create clone
   */
  clone() {
    return HoruzProtocolChulakMessageAgentStartEnterGuard.fromJSON(
      this.toJSON(),
    );
  }
}
